@if(isLoading()) {
<av-loading-item [icon]="'devices'" [textKey]="'shared.general.labels.loading'" />
} @else {
<av-content-container>
    <div class="col-12 d-flex align-items-stretch">
        <av-table-card [titleKey]="'app.user.devices.title'" icon="devices" [columns]="deviceColumns"
            [rows]="deviceRows()" [countLabelKey]="'app.user.devices.count_suffix'"
            [emptyTextKey]="'app.user.devices.empty'" [pageSize]="10" [truncateAfter]="15" />
    </div>
</av-content-container>
}